import { render } from "./EventDetails.vue?vue&type=template&id=5e1df312&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=5e1df312&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1df312"],['__file',"resources/js/views/Event/Create/EventDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e1df312"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e1df312', __exports__)) {
    console.log('reload')
    api.reload('5e1df312', __exports__)
  }
  
  module.hot.accept("./EventDetails.vue?vue&type=template&id=5e1df312&scoped=true", () => {
    console.log('re-render')
    api.rerender('5e1df312', render)
  })

}


export default __exports__